import { productApi } from "./product.api";

export const { useGetProductsQuery, useGetProductQuery, useSaveProductMutation, useDeleteProductMutation, useSearchProductsQuery, useLazySearchProductsQuery } = productApi;
